import { useMemo } from "react";
import { Resources, useResource } from "Translations/Resources";
import { WeekDay } from "Types/WeekDay";

const WEEK_DAY_CODES = Object.values(WeekDay);

type WeekDayOption = {
  id: WeekDay;
  name: string;
};

export const useWeekDayOptions = (): Array<WeekDayOption> => {
  const { t } = useResource();

  return useMemo(
    () =>
      WEEK_DAY_CODES.map((day) => ({
        id: day,
        name: t(Resources.Common.WeekDay[day]),
      })),
    [t],
  );
};
